// This file is generated by tools/races.js

import type { Race } from "../../../common/types.ts";

const defaultRaces: Record<string, Record<Race, number>> = {
	Argentina: {
		asian: 1,
		black: 10,
		brown: 14,
		white: 75,
	},
	Brazil: {
		asian: 1,
		black: 33,
		brown: 33,
		white: 33,
	},
	"Cape Verde": {
		asian: 1,
		black: 28,
		brown: 70,
		white: 1,
	},
	China: {
		asian: 997,
		black: 1,
		brown: 1,
		white: 1,
	},
	Germany: {
		asian: 1,
		black: 15,
		brown: 15,
		white: 69,
	},
	India: {
		asian: 1,
		black: 1,
		brown: 997,
		white: 1,
	},
	Lithuania: {
		asian: 1,
		black: 1,
		brown: 1,
		white: 997,
	},
	Mexico: {
		asian: 1,
		black: 10,
		brown: 79,
		white: 10,
	},
	Nigeria: {
		asian: 1,
		black: 997,
		brown: 1,
		white: 1,
	},
	"South Africa": {
		asian: 1,
		black: 80,
		brown: 10,
		white: 9,
	},
	Spain: {
		asian: 1,
		black: 10,
		brown: 10,
		white: 79,
	},
	Turkey: {
		asian: 1,
		black: 1,
		brown: 18,
		white: 80,
	},
	USA: {
		asian: 1,
		black: 50,
		brown: 35,
		white: 14,
	},
};

defaultRaces["Albania"] = defaultRaces["Lithuania"]!;
defaultRaces["Algeria"] = defaultRaces["India"]!;
defaultRaces["American Samoa"] = defaultRaces["India"]!;
defaultRaces["Angola"] = defaultRaces["Nigeria"]!;
defaultRaces["Armenia"] = defaultRaces["Lithuania"]!;
defaultRaces["Australia"] = defaultRaces["Spain"]!;
defaultRaces["Austria"] = defaultRaces["Spain"]!;
defaultRaces["Azerbaijan"] = defaultRaces["Lithuania"]!;
defaultRaces["Bahamas"] = defaultRaces["Nigeria"]!;
defaultRaces["Belarus"] = defaultRaces["Lithuania"]!;
defaultRaces["Belgium"] = defaultRaces["Germany"]!;
defaultRaces["Benin"] = defaultRaces["Nigeria"]!;
defaultRaces["Bolivia"] = defaultRaces["Mexico"]!;
defaultRaces["Bosnia and Herzegovina"] = defaultRaces["Lithuania"]!;
defaultRaces["Bulgaria"] = defaultRaces["Lithuania"]!;
defaultRaces["Cameroon"] = defaultRaces["Nigeria"]!;
defaultRaces["Canada"] = defaultRaces["USA"]!;
defaultRaces["Central African Republic"] = defaultRaces["Nigeria"]!;
defaultRaces["Chad"] = defaultRaces["Nigeria"]!;
defaultRaces["Chile"] = defaultRaces["Argentina"]!;
defaultRaces["Colombia"] = defaultRaces["Mexico"]!;
defaultRaces["Congo"] = defaultRaces["Nigeria"]!;
defaultRaces["Costa Rica"] = defaultRaces["Mexico"]!;
defaultRaces["Croatia"] = defaultRaces["Lithuania"]!;
defaultRaces["Cuba"] = defaultRaces["Mexico"]!;
defaultRaces["Czech Republic"] = defaultRaces["Germany"]!;
defaultRaces["Denmark"] = defaultRaces["Germany"]!;
defaultRaces["Dominican Republic"] = defaultRaces["Nigeria"]!;
defaultRaces["East Timor"] = defaultRaces["India"]!;
defaultRaces["Egypt"] = defaultRaces["India"]!;
defaultRaces["El Salvador"] = defaultRaces["Mexico"]!;
defaultRaces["England"] = defaultRaces["Germany"]!;
defaultRaces["Ecuador"] = defaultRaces["Mexico"]!;
defaultRaces["Estonia"] = defaultRaces["Lithuania"]!;
defaultRaces["Ethiopia"] = defaultRaces["Nigeria"]!;
defaultRaces["Finland"] = defaultRaces["Spain"]!;
defaultRaces["France"] = defaultRaces["USA"]!;
defaultRaces["French Guiana"] = defaultRaces["Mexico"]!;
defaultRaces["Gabon"] = defaultRaces["Nigeria"]!;
defaultRaces["Georgia"] = defaultRaces["Lithuania"]!;
defaultRaces["Ghana"] = defaultRaces["Nigeria"]!;
defaultRaces["Greece"] = defaultRaces["Spain"]!;
defaultRaces["Guadeloupe"] = defaultRaces["South Africa"]!;
defaultRaces["Guatemala"] = defaultRaces["Mexico"]!;
defaultRaces["Guinea"] = defaultRaces["Nigeria"]!;
defaultRaces["Guinea-Bissau"] = defaultRaces["Nigeria"]!;
defaultRaces["Haiti"] = defaultRaces["Nigeria"]!;
defaultRaces["Honduras"] = defaultRaces["Mexico"]!;
defaultRaces["Hungary"] = defaultRaces["Lithuania"]!;
defaultRaces["Iceland"] = defaultRaces["Lithuania"]!;
defaultRaces["Indonesia"] = defaultRaces["China"]!;
defaultRaces["Iran"] = defaultRaces["Lithuania"]!;
defaultRaces["Ireland"] = defaultRaces["Germany"]!;
defaultRaces["Israel"] = defaultRaces["Lithuania"]!;
defaultRaces["Italy"] = defaultRaces["Spain"]!;
defaultRaces["Ivory Coast"] = defaultRaces["Nigeria"]!;
defaultRaces["Jamaica"] = defaultRaces["Nigeria"]!;
defaultRaces["Japan"] = defaultRaces["China"]!;
defaultRaces["Kazakhstan"] = defaultRaces["China"]!;
defaultRaces["Kenya"] = defaultRaces["Nigeria"]!;
defaultRaces["Kosovo"] = defaultRaces["Lithuania"]!;
defaultRaces["Kyrgyzstan"] = defaultRaces["China"]!;
defaultRaces["Laos"] = defaultRaces["China"]!;
defaultRaces["Latvia"] = defaultRaces["Lithuania"]!;
defaultRaces["Liberia"] = defaultRaces["Nigeria"]!;
defaultRaces["Luxembourg"] = defaultRaces["Spain"]!;
defaultRaces["Macau"] = defaultRaces["China"]!;
defaultRaces["Mali"] = defaultRaces["Nigeria"]!;
defaultRaces["Moldova"] = defaultRaces["Lithuania"]!;
defaultRaces["Montenegro"] = defaultRaces["Lithuania"]!;
defaultRaces["Morocco"] = defaultRaces["India"]!;
defaultRaces["Mozambique"] = defaultRaces["Nigeria"]!;
defaultRaces["Nepal"] = defaultRaces["India"]!;
defaultRaces["Netherlands"] = defaultRaces["Spain"]!;
defaultRaces["New Zealand"] = defaultRaces["Lithuania"]!;
defaultRaces["Nicaragua"] = defaultRaces["Mexico"]!;
defaultRaces["North Korea"] = defaultRaces["China"]!;
defaultRaces["North Macedonia"] = defaultRaces["Lithuania"]!;
defaultRaces["Norway"] = defaultRaces["Spain"]!;
defaultRaces["Pakistan"] = defaultRaces["India"]!;
defaultRaces["Panama"] = defaultRaces["Mexico"]!;
defaultRaces["Papua New Guinea"] = defaultRaces["China"]!;
defaultRaces["Paraguay"] = defaultRaces["Mexico"]!;
defaultRaces["Peru"] = defaultRaces["Mexico"]!;
defaultRaces["Philippines"] = defaultRaces["India"]!;
defaultRaces["Poland"] = defaultRaces["Lithuania"]!;
defaultRaces["Portugal"] = defaultRaces["Spain"]!;
defaultRaces["Puerto Rico"] = defaultRaces["USA"]!;
defaultRaces["Romania"] = defaultRaces["Lithuania"]!;
defaultRaces["Russia"] = defaultRaces["Lithuania"]!;
defaultRaces["Samoa"] = defaultRaces["India"]!;
defaultRaces["Scotland"] = defaultRaces["Spain"]!;
defaultRaces["Senegal"] = defaultRaces["Nigeria"]!;
defaultRaces["Serbia"] = defaultRaces["Lithuania"]!;
defaultRaces["Slovakia"] = defaultRaces["Spain"]!;
defaultRaces["Slovenia"] = defaultRaces["Lithuania"]!;
defaultRaces["South Korea"] = defaultRaces["China"]!;
defaultRaces["South Sudan"] = defaultRaces["Nigeria"]!;
defaultRaces["Sudan"] = defaultRaces["Nigeria"]!;
defaultRaces["Sweden"] = defaultRaces["Spain"]!;
defaultRaces["Switzerland"] = defaultRaces["Germany"]!;
defaultRaces["Taiwan"] = defaultRaces["China"]!;
defaultRaces["Thailand"] = defaultRaces["China"]!;
defaultRaces["Trinidad and Tobago"] = defaultRaces["Cape Verde"]!;
defaultRaces["Ukraine"] = defaultRaces["Lithuania"]!;
defaultRaces["Uruguay"] = defaultRaces["Argentina"]!;
defaultRaces["Uzbekistan"] = defaultRaces["Lithuania"]!;
defaultRaces["Venezuela"] = defaultRaces["Argentina"]!;
defaultRaces["Vietnam"] = defaultRaces["China"]!;
defaultRaces["Virgin Islands"] = defaultRaces["South Africa"]!;
defaultRaces["Wales"] = defaultRaces["Germany"]!;

export default defaultRaces;
